import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  ConfiguracionVehicularSigoEnum,
  TipoEngancheModularSigoEnum,
} from "../../models/vehiculo-models";

@Component({
  selector: "[app-sigo-vehiculo]",
  templateUrl: "./sigo-vehiculo.component.html",
  styleUrls: ["./sigo-vehiculo.component.scss"],
})
export class SigoVehiculoComponent implements OnInit, OnChanges, AfterViewInit {
  @Input("ejesPrimerVehiculo") ejesPrimerVehiculo: number = 0;
  @Input("ejesSegundoVehiculo") ejesSegundoVehiculo: number = 0;
  @Input("ejesTercerVehiculo") ejesTercerVehiculo: number = 0;
  @Input("textoImagen") textoImagen: string = "";
  @Input("mostrarDistancias") mostrarDistancias: boolean = true;
  @Input("configuracionVehicular")
  configuracionVehicular: ConfiguracionVehicularSigoEnum =
    ConfiguracionVehicularSigoEnum.TractoCiguena;
  @Input("tipoEngancheModular")
  tipoEngancheModular: TipoEngancheModularSigoEnum =
    TipoEngancheModularSigoEnum.Remolque;
  @Input("mostrarEsImagenRef") mostrarEsImagenRef: boolean = false;

  @ViewChild("seccionSegundoVehiculo", {
    static: false,
  })
  seccionSegundoVehiculo: ElementRef;
  @ViewChild("seccionLetraE", {
    static: false,
  })
  seccionLetraE: ElementRef;

  debeMostrarDistancias: boolean = true;
  configVehicularEnum = ConfiguracionVehicularSigoEnum;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {}

  ngOnInit(): void {
    console.log("COMPONENTE VEHICULO");
  }

  ngAfterViewInit() {}
}
